<template>
  <v-base-layout>
    <div class="d-flex fill-height bg-pattern-image">
      <v-col md="6" class="hidden-sm-and-down pa-0">
        <div class="bg-circuit-image fill-height" />
      </v-col>
      <v-col md="6" class="d-flex flex-column justify-center pa-0">
        <div class="d-flex pl-4 justify-start application-logo">
          <LogoApp :height="60" />
        </div>
        <div class="mt-6 mb-8 pl-4 error-message">
          <h1>{{ title }}</h1>
          <h3 class="mt-4">
            {{ message }}
          </h3>
        </div>
        <div class="mt-4 pl-4 error-actions">
          <client-only>
            <a-btn data-test-id="error-return-home" @click="navigateTo">
              {{ $t('_core.error.returnToHome') }}
            </a-btn>
          </client-only>
        </div>
      </v-col>
    </div>
  </v-base-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import LogoApp from '@/components/_core/ui/logo';

export default {
  props: {
    error: {
      type: Object
    }
  },
  components: {
    LogoApp
  },
  data() {
    return {
      title   : null,
      message : null
    };
  },
  head() {
    const errorKey = this.getErrorKey();
    return { title: this.$t(`_core.error.${errorKey}.pageTitle`) };
  },
  created() {
    const errorKey = this.getErrorKey();
    this.title = this.$t(`_core.error.${errorKey}.title`);
    this.message = this.$t(`_core.error.${errorKey}.message`);
  },
  computed: {
    ...mapGetters({
      isImpersonated: '_core/auth/isImpersonated'
    })
  },
  methods: {
    navigateTo() {
      if (this.$route.path === '/') {
        this.$router.go();
      }
      this.$router.push('/');
    },
    getErrorKey() {
      const status = this.error?.statusCode;
      if ([401, 403, 404].includes(status)) {
        return String(status);
      }
      return '500';
    }
  }
};
</script>

<style scoped lang="scss">
.theme--dark {
    .bg-pattern-image::before {
        opacity: 0.3;
    }

    .bg-circuit-image::before {
        opacity: 0.93;
    }

    .error-message {
        h1, h3 {
            color: #ffffff;
        }
    }
}

.core-is-impersonated {
  ::v-deep {
    .v-application--wrap {
      border: 4px solid #36a9e1;
    }
  }
}

.bg-pattern-image {
    position: relative;
}

.bg-pattern-image::before {
    content: '';
    background: transparent url('~/assets/_core/img/error/pattern.svg') repeat;
    background-size: cover;
    height: 100%;
    width: 100%;
    position: absolute;
}

.bg-circuit-image {
   position: relative;
}

.bg-circuit-image::before {
    content: '';
    background: transparent url('~/assets/_core/img/error/circuit.gif') no-repeat;
    background-size: cover;
    height: 100%;
    width: 100%;
    position: absolute;
}

::v-deep {
    .application-logo {
        @media only screen and (max-device-width: 768px) {
          justify-content: center !important;

          .v-image {
            max-width: 70% !important;
          }

          .v-image__image.v-image__image--contain {
            background-position: center !important;
          }
        }
    }
}

.error-message {
    @media only screen and (max-width: 768px) {
        padding: 0 28px;

        h1 {
          font-size: 2.286rem !important;
          text-align: center;
        }

        h3 {
          font-size: 1.286rem !important;
          text-align: center;
        }
    }
    padding-right: 140px;
    position: relative;

    h1 {
        font-size: 3.429rem;
        font-weight: 900;
        letter-spacing: 0.4px;
        color: var(--v-neutrals-800-base);
    }

    h3 {
        font-size: 1.714rem;
        font-weight: 400;
        letter-spacing: 0.36px;
        color: var(--v-neutrals-800-base);
    }
}

.error-actions {
    @media only screen and (max-width: 768px) {
      text-align: center;
      padding: 0 28px;

       .v-btn {
         width: 100% !important;
       }
    }
    position: relative;

    .v-btn {
        background-color: var(--v-neutrals-800-base) !important;
        padding: 15px 20px !important;
        letter-spacing: 0.28px !important;
        font-weight: 700;
        color: #ffffff;
    }
}
</style>
